import React from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.css';
import TableRows from './TableRows';

function GeneralInformationTable({rowsData,setRowsData}){

    const addTableRows=()=>{
  
        const rowsInput={
            partNumber:'',
            reasonForScrap:'',
            quantity:'',
            PO_SA_Number:'',
            QN_RFA_Number:'',
            serialNumber:''         

        } 
        setRowsData([...rowsData, rowsInput])
      
    }
   const deleteTableRows = (index)=>{
        const rows = [...rowsData];
        rows.splice(index, 1);
        setRowsData(rows);
   }
 
   const handleChange = (index, evnt)=>{
    
    const { name, value } = evnt.target;
    const rowsInput = [...rowsData];
    rowsInput[index][name] = value;
    setRowsData(rowsInput);
  
 
 
}
    return(
        <div>
            <div className="row"> <div className="col-12"><h5 className="generalInfoStyle">General Information</h5></div></div>
            <div class="marginLeft">
            <div class="row"> <div class="GeneralInfoNote"><b>Enter N/A if the following fields are not applicable (PO/SA Number, QN/RFA Number, Serial Number). Do not leave these fields blank</b></div></div>
            <div className="row">
                <div className="col-12">
                <table className="table">
                    <thead>
                      <tr>
                          <th>ID</th>
                          <th>Part Number<label style={{color:'red'}}>*</label></th>
                          <th>Reason for Scrap<label style={{color:'red'}}>*</label></th>
                          <th>Quantity<label style={{color:'red'}}>*</label></th>
                          <th>PO/SA Number<label style={{color:'red'}}>*</label></th>
                          <th>QN/RFA Number<label style={{color:'red'}}>*</label></th>
                          <th>Serial Number<label style={{color:'red'}}>*</label></th>                          
                          <th><span className="btn btn-outline-success" onClick={addTableRows} >+</span></th>
                      </tr>
                    </thead>
                   <tbody>
                   <TableRows rowsData={rowsData} deleteTableRows={deleteTableRows} handleChange={handleChange} />
                   </tbody> 
                </table>
                </div>                
            </div>

            <div>
            <span className="btn btn-outline-success" onClick={addTableRows} >+Add </span>
            </div>
            </div>
        </div>
    )


}

export default GeneralInformationTable;